import React, { useContext, useState } from "react";
import { Box, Button, Card, Grid, Popper, Typography } from "@mui/material";
import { Formik } from "formik";
import { CheckCircleOutline, HighlightOff, RadioButtonUnchecked, Save } from "@material-ui/icons";
import * as Yup from "yup";
import { BrandContext } from "../../../contexts/BrandContext";
import BasicInputField from "../form/BasicInputField";
import { initialValues } from "../form/FormUtilities";
import axios from "../../../utils/axios";
import { cWarn } from "../CustomLogger";
import { TaxiBookingContext } from "./BookTaxiContext";
import { serializeAddress } from "./BookTaxiUtilities";
import BlurHandler from "./BlurHandler";

export default function LocationSetter(props){

    const taxiBookingContext = useContext(TaxiBookingContext);
    const brandContext = useContext(BrandContext);
    
    const {
        focusKey='',
        focusIndex,
        setFocus,
        removeViaAtIndex
    } = taxiBookingContext;

    

    const {
        textContent:{
            enterAddressManually='',
            removeViaButton='',
            widget_saveButton:save=''
        },
        textContent
    } = brandContext;

    const {
        titleLabel='',
        bookingHook='',
        slideIndex=0
    } = props;

    const isFocused = ((bookingHook === focusKey) && (slideIndex === focusIndex));

    const formFields = {
        'knownOrNew':{
            label:titleLabel,
            type: 'radioButton',
            options:[
                {
                    value:'1',
                    label:'aKnownAddress'
                },
                {
                    value:'0',
                    label:'aNewAddress'
                }
            ],
            default:'1'
        },
        'knownAddress':{
            label:'enterAddress',
            type: 'typeahead',
            apiLookupPath:'/knownplaces/',
            optionTemplate:(option) => `${option.label}`,
            default:null,
            required:false
        },
        'startTyping': {
            'label': 'startTypingAddress',
            'type': 'typeahead',
            'apiLookupPath':'/address/autocomplete/',
            'optionTemplate':(option) => `${option.address}`,
            'default':null,
            required:false
        },
        'houseName': {
            'label': 'additionalAddressHouseName',
            required:false
        },
        'houseNumber': {
            'label': 'additionalAddressHouseNumber',
            required:false
        },
        'street': {
            'label': 'additionalAddressStreet',
            required:false
        },
        'town': {
            'label': 'additionalAddressTown',
            required:false
        },
        'country': {
            'label': 'additionalAddressCountry',
            required:false
        },
        'postcode': {
            'label': 'additionalAddressPostcode',
            required:false
        },
    }

    const validationSchema = Yup.object().shape({
        knownOrNew: Yup.string().required('This field is required'),
        knownAddress: Yup.mixed().nullable().when('knownOrNew', {
          is: '1',
          then: Yup.mixed().required('Known Address is required when knownOrNew is 1'),
        }),
        postcode: Yup.string().ensure().when('knownOrNew', {
          is: '0',
          then: Yup.string().required('Postcode is required when knownOrNew is 2'),
        }),
      });

    const selectAddressAndMoveOn = (addr,callBack) =>{

        const apiPath = `${process.env.REACT_APP_API_URL}/address/lookup/${addr.id}`;
    
        axios.get(apiPath,{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            
            const {data} = res;
            const {
                line_1:line1 = '',
                line_2:line2='',
                thoroughfare='',
                building_name:buildingName = '',
                building_number:houseNumber = '',
                post_town:townOrCity = '',
                postcode = '',
                dependant_locality:locality = '',
                country=''
            } = data;
    
            let street = '';
            if(thoroughfare){
                street = thoroughfare;
            }
            else{
                street = line2;
            }
    
    
            const houseName = (!buildingName && !houseNumber ? line1 : buildingName);
            
            const townParts = [];
            if(locality){
                townParts.push(locality);
            }
            if(townOrCity){
                townParts.push(townOrCity);
            }
            const town = townParts.join(', ');
    
            if(callBack){
                callBack({
                    houseName,
                    houseNumber,
                    street,
                    town,
                    country,
                    postcode
                });
            }
        }).catch(err => {
            cWarn(err);
        });
    }
    

    const [enterManuallyFields,setEnterManuallyFields] = useState(false);

    const bookingDataObject = bookingHook === 'via' ? taxiBookingContext.bookingData.vias[slideIndex] : taxiBookingContext.bookingData[bookingHook];

    const {isSubmitted} = bookingDataObject;

    const sectionReady = (formik) => {
        const{
            errors
        } = formik;
        if((Object.keys(errors).length === 0) && isSubmitted){
            return true;
        }
        return false;
    }

    return (
        <Formik
            initialValues={initialValues(formFields)}
            validationSchema={validationSchema}
            onSubmit={(values)=>{
                bookingDataObject.data = values;
                bookingDataObject.isSubmitted = true;
                taxiBookingContext.setState({
                    focusKey:'',
                    fpsAvailable:[]
                });
                taxiBookingContext.checkTaxiAvailability();
            }}
        >
            {formikProps => (
                <BlurHandler formikProps={formikProps} {...props}>
                    <Card 
                        variant="outlined" 
                        className={`${isFocused && 'sectionFocused'} ${sectionReady(formikProps) && 'sectionReady'} lightBox sectionBox formContainer`} 
                        onFocus={()=>{
                            if(!isFocused){
                                setFocus(bookingHook,slideIndex)
                            }
                        }}
                        onClick={()=>{
                            if(!isFocused){
                                setFocus(bookingHook,slideIndex)
                            }
                        }}
                    >
                        {isFocused ?  
                            <Box sx={{position:'relative', zIndex:5000}}>
                                <form onSubmit={formikProps.handleSubmit}>
                                    <Grid container spacing={3}>
                                    <>
                                        <Grid item xs={12} md={12}>
                                            <BasicInputField
                                                sx={{width:'100%'}}  
                                                formik={formikProps}
                                                formFields={formFields} 
                                                fieldName="knownOrNew"
                                                className="boldLabel"
                                            />    
                                        </Grid>
                                        {formikProps.values.knownOrNew === '1' ?
                                            
                                            <Grid item xs={12} md={12} className="boxyAutoComplete_mod">
                                                <BasicInputField
                                                    sx={{
                                                        width:'100%'}}  
                                                    
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="knownAddress"
                                                    
                                                />    
                                            </Grid>
                                            :
                                            <>
                                            <Grid item xs={12} md={12} className="boxyAutoComplete_mod" >
                                                
                                                <BasicInputField formik={formikProps}formFields={formFields} fieldName="startTyping"  changeHandle={(value)=>{
                                                    selectAddressAndMoveOn(value,(data) => {
                                                        /* eslint-disable */
                                                        for(var i in data){
                                                            formikProps.setFieldValue(`${i}`,data[i]);
                                                        }
                                                        /* eslint-enable */
                                                    })
                                                }} />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Button onClick={()=>{setEnterManuallyFields(enterManuallyFields === false)}}>{enterAddressManually}</Button>
                                            </Grid>
                                            {enterManuallyFields &&
                                                <>
                                                    <Grid item xs={12} md={3}>
                                                        <BasicInputField formik={formikProps} formFields={formFields}  fieldName="houseNumber"/>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <BasicInputField formik={formikProps} formFields={formFields}  fieldName="houseName"/>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <BasicInputField formik={formikProps} formFields={formFields}  fieldName="street"/>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <BasicInputField formik={formikProps} formFields={formFields}  fieldName="town"/>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <BasicInputField formik={formikProps} formFields={formFields}  fieldName="postcode"/>
                                                    </Grid>
                                                </>
                                            }
                                            </>
                                        }
                                        </>
                                    </Grid>
                                </form>        
                            </Box>
                        :
                        <Box className="sectionSummary">
                            {sectionReady(formikProps) ?
                                <Box className="iconContainer iconReady"><CheckCircleOutline/></Box>
                            :
                                <Box className="iconContainer"><RadioButtonUnchecked/></Box>
                            }
                            <Box>
                                <Typography variant="subtitle1">{textContent[titleLabel]} {serializeAddress(bookingDataObject.data)}</Typography>
                            </Box>
                        </Box>
                        }
                        <Box className="dialogueSectionToolsContainer">
                            {isFocused &&
                                <Button 
                                    size="small"    
                                    startIcon={<Save/>}
                                    variant="contained"
                                    type="submit"
                                    onClick={()=>{
                                        formikProps.handleSubmit()
                                    }}
                                    >
                                    {save}
                                </Button>
                            }
                            {bookingHook === 'via' &&
                                <Button 
                                    size="small"    
                                    startIcon={<HighlightOff/>}
                                    variant="contained"    
                                    onClick={()=>{
                                        removeViaAtIndex(slideIndex)
                                }}>
                                    {removeViaButton}
                                </Button>
                            }
                        </Box>
                    </Card>
                </BlurHandler>
            )}
        </Formik>
    );

    


}